export default "__VITE_ASSET__CImJwRgg__"